import { inject, Pipe, PipeTransform } from '@angular/core';

import { CHANNEL_VIDEO_CTA_TRANSLATIONS, channelVideoCtaTranslations } from '@usheru-hff/sdk/channel';

const CHANNEL_VIDEO_CTA_TRANSLATION_PREFIX = 'channel-video.cta.';

@Pipe({
  name: 'channelVideoCtaLocalize',
  standalone: true,
  pure: true
})
export class ChannelVideoCtaLocalizePipe implements PipeTransform {
  customTranslations = inject(CHANNEL_VIDEO_CTA_TRANSLATIONS, { optional: true }) as Record<string, string>;

  transform(key: string, placeholder?: string): string {
    const translationKey = `${CHANNEL_VIDEO_CTA_TRANSLATION_PREFIX}${key}`;
    const localized = this.customTranslations?.[translationKey] || channelVideoCtaTranslations[translationKey];
    const fallback = placeholder || key;

    return localized || fallback;
  }
}
